/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'system-update';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleAttributes = `${prefix}.columnTitleAttributes`;
export const emptyGridPlaceholder = `${prefix}.emptyGridPlaceholder`;
export const updateLabel = `${prefix}.updateLabel`;
export const segLabel = `${prefix}.segLabel`;
export const systemLabel = `${prefix}.systemLabel`;
export const clearPatchLabel = `${prefix}.clearPatchLabel`;
export const nonOperationalFipsMessage = `${prefix}.nonOperationalFipsMessage`;
export const currentVersionLabel = `${prefix}.currentVersionLabel`;
export const availableUpdatesLabel = `${prefix}.availableUpdatesLabel`;
export const newUpgradeLabel = `${prefix}.newUpgradeLabel`;
export const loadingRecentLabel = `${prefix}.loadingRecentLabel`;

export const ENGLISH = {
    [updateLabel]: 'Update',
    [segLabel]: 'Service Engine Groups',
    [systemLabel]: 'System',
    [clearPatchLabel]: 'Clear Patch',
    [columnTitleAttributes]: 'Attributes',
    [emptyGridPlaceholder]: 'No Compatible Image Found.',
    [nonOperationalFipsMessage]: 'Something went wrong and FIPS is currently non operational. Please set up compliance mode again.',
    [currentVersionLabel]: '{0} (current)',
    [availableUpdatesLabel]: 'Available updates ({0})',
    [newUpgradeLabel]: 'New Upgrade',
    [loadingRecentLabel]: 'Loading Recent',
};
